// footer {
//     text-align: center;
//     position: fixed;
//     bottom: 0;
// }

export default function Footer() {
	return null;
	// return (
	//   <footer>
	//     {/* <Uploader/> */}
	//   </footer>
	// );
}
